import React, {useState, useEffect} from 'react';
import ProjectsHeaderContainer from '../containers/projects-header';
import JumbotronContainer  from '../containers/jumbotron';
import  Feature from '../components/feature/index';
import FooterContainer from '../containers/footer';
import {Slide} from 'react-reveal';
import projectsData from '../fixtures/jumbo';
import { useParams } from 'react-router-dom';

export default function Projects () {
    const params = useParams ();
    const [title, setTitle] = useState('');
    const [subtitle, setSubTitle] = useState('');

    useEffect(() => {
        window.scrollTo(0, 0);
        const {type} = params;
        switch (type) {
            case "webapplicationdevelopment":
                setTitle(projectsData[0].title);
                setSubTitle(projectsData[0].subtitle);
                break;
            case "androidapplicationdevelopment":
                setTitle(projectsData[1].title);
                setSubTitle(projectsData[1].subtitle);
                break;
            case "c++programming":
                setTitle(projectsData[2].title);
                setSubTitle(projectsData[2].subtitle);
                break;  
            case "machinelearning":
                setTitle(projectsData[3].title);
                setSubTitle(projectsData[3].subtitle);
                break;      
            case "dataanalysis":
                setTitle(projectsData[4].title);
                setSubTitle(projectsData[4].subtitle);
                break;        
            default:
                setTitle("No Such Project Category");
                setSubTitle("");
                break;
        }
    },[title,subtitle, params]);

    return (
        <>
            <ProjectsHeaderContainer>
                <Feature>
                    <Slide left>
                        <Feature.Title>
                            {title}
                        </Feature.Title>
                    </Slide>
                    <Slide right>
                        <Feature.SubTitle>
                            {subtitle}
                        </Feature.SubTitle>
                    </Slide>
                </Feature>
            </ProjectsHeaderContainer>
            <JumbotronContainer params= {params} />
            <FooterContainer />
        </>
    );
}